import { get } from 'lodash/fp';
import { ApplicationMarket } from '../../../../../api/types';
import validators from '../../../../../utilities/validators';
import { singaporeMarketValidator } from '../../shared/validators';

const validator = validators.compose(
    validators.requiredNonEmptyString('displayName'),
    validators.requiredString('identifier'),
    validators.requiredString('bankModuleId'),
    validators.requiredArray('vehicleModuleIds'),
    validators.requiredString('market'),
    validators.only(values => {
        const marketType = get('market', values);

        return marketType === ApplicationMarket.Singapore;
    }, singaporeMarketValidator)
);

export const updateValidator = validators.compose(
    validators.requiredNonEmptyString('displayName'),
    validators.requiredString('identifier'),
    validators.requiredString('market'),
    validators.only(values => {
        const marketType = get('market', values);

        return marketType === ApplicationMarket.Singapore;
    }, singaporeMarketValidator)
);

export default validator;
